import * as React from 'react';
import { SVGProps } from 'react';


const PartnerAllMerchant = (props: SVGProps<any>): JSX.Element => (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 22}
    height={props.height || 22}
    viewBox="0 0 26 26"
    fill="none"
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      d="M23.7996 25.0004H2.19922"
      stroke="#282C44"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21.3999 25.0001V16.6"
      stroke="#282C44"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4.59961 25.0001V16.6"
      stroke="#282C44"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.4332 0.999634H7.5662C6.12279 0.999634 5.40109 0.999634 4.82111 1.35808C4.24114 1.71652 3.91838 2.36204 3.27287 3.65306L1.49033 8.15909C1.16604 8.97885 0.894692 9.9181 1.36059 10.6665C1.78419 11.3469 2.53891 11.7998 3.39945 11.7998C4.72496 11.7998 5.7995 10.7253 5.7995 9.3998C5.7995 10.7253 6.87404 11.7998 8.19955 11.7998C9.52506 11.7998 10.5996 10.7253 10.5996 9.3998C10.5996 10.7253 11.6741 11.7998 12.9996 11.7998C14.3252 11.7998 15.3997 10.7253 15.3997 9.3998C15.3997 10.7253 16.4742 11.7998 17.7997 11.7998C19.1252 11.7998 20.1998 10.7253 20.1998 9.3998C20.1998 10.7253 21.2743 11.7998 22.5998 11.7998C23.4604 11.7998 24.2151 11.3469 24.6388 10.6665C25.1047 9.9181 24.8334 8.97885 24.5091 8.15909L22.7265 3.65306C22.081 2.36204 21.7583 1.71652 21.1783 1.35808C20.5983 0.999634 19.8766 0.999634 18.4332 0.999634Z"
      fill="#282C44"
      fillOpacity="0.2"
      stroke="#282C44"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default PartnerAllMerchant;
